import { ValidatorFn } from '@angular/forms';

export const FILES = 'file';
export const DROP_DOWN = 'dropdown';
export const CHECK_BOX = 'checkbox';
export const TEXT_AREA = 'textarea';
export const TEXT_BOX = 'textbox';
export const BUSINESS_USER = 'vbcuser';

export type ControlType = 'checkbox' | 'dropdown' | 'file' | 'textbox' | 'textarea' | 'vbcuser';

export interface FieldBaseOptions {
  // TODO This and marketplace-apps OrderFormFieldInterface should share a common base
  id: string;
  label: string;
  required?: boolean;
  description?: string;
  type?: string;
  prefix?: string;
  suffix?: string;
  regexValidator?: string;
  regexErrorMessage?: string;
  disabled?: boolean;
  forOfficeUseOnly?: boolean;
  officeEditableOnly?: boolean;
  hidden?: boolean;
  displayOnly?: boolean;
}

export abstract class FieldBase<T> implements FieldBaseOptions {
  value: T;
  id: string;
  label: string;
  required: boolean;
  order: number;
  description: string;
  controlType: ControlType;
  prefix: string;
  suffix: string;
  regexValidator: string;
  regexErrorMessage: string;
  disabled: boolean;
  validator: ValidatorFn;
  forOfficeUseOnly: boolean;
  officeEditableOnly: boolean;
  hidden: boolean;
  displayOnly: boolean;

  constructor(options: FieldBaseOptions) {
    this.id = options.id;
    this.label = options.label;
    this.required = !!options.required;
    this.description = options.description || null;
    options.type = options.type === 'text' ? 'textbox' : options.type;
    this.controlType = options.type as ControlType;
    this.prefix = options.prefix;
    this.suffix = options.suffix;
    this.regexValidator = options.regexValidator;
    this.regexErrorMessage = options.regexErrorMessage;
    this.disabled = options.disabled || false;
    this.validator = this.validatorBuilder();
    this.forOfficeUseOnly = !!options.forOfficeUseOnly;
    this.officeEditableOnly = !!options.officeEditableOnly;
    this.hidden = options.hidden;
    this.displayOnly = options.displayOnly;
  }

  protected validatorBuilder(): ValidatorFn {
    return (): { [key: string]: any } => {
      return null;
    };
  }
}
